import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, Dispatch, SetStateAction, use } from "react";

type ProductComparisonContextValue = {
    allowInstantAddToCart: boolean;
    differenceOnly: boolean;
    setDifferenceOnly: Dispatch<SetStateAction<boolean>>;
    skus: Array<string>;
    setSkus: Dispatch<SetStateAction<Array<string>>>;
};

type ProductComparisonContextProviderProps = {
    allowInstantAddToCart: boolean;
    differenceOnly: boolean;
    setDifferenceOnly: Dispatch<SetStateAction<boolean>>;
    skus: Array<string>;
    setSkus: Dispatch<SetStateAction<Array<string>>>;
};

export const ProductComparisonContext = createContext<
    ProductComparisonContextValue | undefined
>(undefined);
ProductComparisonContext.displayName = "ProductComparisonContext";

export const ProductComparisonContextProvider = ({
    allowInstantAddToCart,
    differenceOnly,
    setDifferenceOnly,
    skus,
    setSkus,
    children
}: RequireChildrenFor<ProductComparisonContextProviderProps>) => (
    <ProductComparisonContext
        value={{
            allowInstantAddToCart: allowInstantAddToCart,
            differenceOnly: differenceOnly,
            setDifferenceOnly: setDifferenceOnly,
            skus: skus,
            setSkus: setSkus
        }}
    >
        {children}
    </ProductComparisonContext>
);

export const useProductComparisonContext = () => {
    const context = use<ProductComparisonContextValue | undefined>(
        ProductComparisonContext
    );

    if (!isDefined(context)) {
        throw new Error(
            `${ProductComparisonContext.displayName} is undefined.`
        );
    }

    return context;
};
